import { RequestOptionsService } from "./requestOptions";
import request from "request-promise";
import { Printer } from "@/models/Printer";

export class PrinterSettingService {
  public static async getPrinterSettings(deviceUdid?: string) {
    const options = RequestOptionsService.getBrearerOptions(deviceUdid ? `PrinterSettings/${deviceUdid}` : "PrinterSettings");
    const result = await request(options);
    return result;
  }

  public static async updatePrinterSettings(deviceUDID: string, data: Printer) {
    const options = RequestOptionsService.postBrearerOptions(`PrinterSettings/UpdateSetting/${deviceUDID}`, {
      ID: data.id,
      BrandName: data.brandName,
      ModelName: data.modelName,
      PrinterIp: data.printerIp,
      IsActive: data.isActive
    });
    const result = await request(options);
    return result;
  }

  public static async addPrinterSettings(deviceUDID: string, data: Printer) {
    const options = RequestOptionsService.postBrearerOptions(`PrinterSettings/UpdateSetting/${deviceUDID}`, {
      ID: null,
      BrandName: data.brandName,
      ModelName: data.modelName,
      PrinterIp: data.printerIp,
      IsActive: data.isActive
    });
    const result = await request(options);
    return result;
  }
}
